import { useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom-v5-compat";
import { CAR_URL_PARAM_KEYS, getCarRoutes } from "@tenant/cars";
import type { CarAvailabilityLinkType } from "./CarAvailabilityLink";

export const useCarAvailabilityLink = ({ car }: CarAvailabilityLinkType) => {
  const { FULL_ROUTES } = getCarRoutes();

  const [params] = useSearchParams();

  const updatedParams = useMemo(() => {
    const newParams = new URLSearchParams(params);
    newParams.set(CAR_URL_PARAM_KEYS.SHOP_ID, car.vehicle.id);
    return newParams;
  }, [params, car.vehicle.id]);

  const navigate = useNavigate();

  const link = `${FULL_ROUTES.SHOP}?${updatedParams.toString()}`;

  return useMemo(() => {
    return {
      link,
      goToShop: () => {
        navigate(link);
      },
    };
  }, [link, navigate]);
};
